module.exports = `${require.publicPath}402.cfbc8bf5.png`;